import {sortSession} from '../util/utils';

const initialState={
  ptSessions    : null,
  quizResult    : null,
  quizScore     : null,
  quizWeeks     : [],
  session       : [],
};

function proReducer(state=initialState, action){
  switch (action.type){
    case "GET_PT_FULFILLED":{
      return Object.assign({}, state, {
        ptSessions: action.payload
      });
    }

    case "GET_QUIZ_WEEKS_FULFILLED":{
      return Object.assign({}, state, {
        quizWeeks: action.payload
      });
    }

    case "GET_QUIZ_RESULT_FULFILLED":{
      return Object.assign({}, state, {
        quizResult: action.payload
      });
    }

    case "GET_SCORE_FULFILLED":{
      return Object.assign({}, state, {
        quizScore: action.payload
      });
    }

    case "GET_PT_DETAUL_FULFILLED":{
      return Object.assign({}, state, {
        session: action.payload
      });
    }

    case "GET_SESSION_FULFILLED":{
      let session = state.ptSessions.filter(val=>val.id===action.payload);
      let sortedSession = sortSession(session);
      return Object.assign({}, state, {
        session: {data:sortedSession}
      });
    }

    default:
      return state;
  }
}

export default proReducer;



// WEBPACK FOOTER //
// ./src/reducers/ProReducer.js